import {observable} from 'mobx';
import {construct, ModelProperties} from 'utils';

export class Redirect {
    @observable id!: number;

    @observable source!: string;
    @observable destination!: string;
    @observable statusCode!: number;
    @observable date!: number | string;

    constructor(redirect?: ModelProperties<Redirect>) {
        if (redirect) {
            construct(this, redirect);
        }
    }
}